import type { SVGProps } from 'react';

/**
 * Generischer Empty-State — leere Ablage mit einer Karte in der Hausfarbe, im Stil der
 * Katalog-Illustration. Fuer Faelle, wo keine der spezifischen Illustrationen passt.
 */
export function EmptyGenericIllustration(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M20 72 L32 44 H96 L108 72 V94 a4 4 0 0 1 -4 4 H24 a4 4 0 0 1 -4 -4 Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        opacity="0.5"
      />
      <path
        d="M20 72 H46 a18 10 0 0 0 36 0 H108"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
        opacity="0.5"
      />
      <rect
        x="44"
        y="28"
        width="40"
        height="30"
        rx="3"
        className="text-brand-500"
        stroke="currentColor"
        strokeWidth="1.5"
        fill="currentColor"
        fillOpacity="0.10"
      />
      <line x1="52" y1="38" x2="76" y2="38" className="text-brand-500" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" />
      <line x1="52" y1="46" x2="68" y2="46" className="text-brand-500" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
    </svg>
  );
}
